var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"empty-history"},[_c('span',{staticClass:"empty-history__icon icon-file-fill"}),_c('h3',{staticClass:"empty-history__title"},[_vm._v("Пока ничего нет")]),_c('p',{staticClass:"empty-history__text"},[_vm._v(" Здесь будет отображаться информация о ваших получаемых и предоставляемых услугах ")])])
}]

export { render, staticRenderFns }